// extracted by mini-css-extract-plugin
export default {"wrapper":"I7-z","boldPrefix":"J7-z","link":"K7-z","message":"L7-z","image":"M7-z"};